import React from 'react';
import { BiGridAlt } from 'react-icons/bi';
import { AiOutlineCalendar } from 'react-icons/ai';
import { useTheme } from 'components/common/ThemeContext';
import moment from 'moment';

const UserCard = ({ userInfo = {}, onLogs = () => {} }) => {
  const { theme } = useTheme();

  // Safely extract nested data with default values
  const lastQueryLogs = userInfo?.last_query_logs || {};
  const createdAt = lastQueryLogs.created_at || null;
  const taskStatus = lastQueryLogs.task_status || null;
  const executionTime = lastQueryLogs.execution_time || 'N/A';
  const noOfSubtasks = lastQueryLogs.no_of_subtasks || 'N/A';
  const query = lastQueryLogs.user_query  || 'N/A';

  return (
    <div className="w-full flex flex-col p-3 md:p-5 rounded-[5px] border-2 border-[#666567]">
      {createdAt ? (
        <p className="text-center flex mx-auto font-Inter text-[12px] text-[#4B4B4B] dark:text-white">
          {moment(createdAt).format('DD/MM/YYYY, hh:mm A')}
        </p>
      ) : (
        <p className="text-center flex mx-auto font-Inter text-[12px] text-[#4B4B4B] dark:text-white">
          No Date Available
        </p>
      )}

      <div className="flex justify-end">
        <div
          className={`w-[24px] h-[24px] rounded-full ${
            taskStatus === 'success' ? 'bg-[#72CC27]' : 'bg-red-400'
          }`}
        />
      </div>

      <div className="flex flex-col w-full">
        <p className="font-InterBold uppercase text-[17px] font-bold dark:text-white truncate">
          {userInfo.username || 'Unknown User'}
        </p>
        <p className="font-Inter text-[13px] text-[#4B4B4B] dark:text-white">
          {userInfo.email || 'No Email Provided'}
        </p>
      </div>

      <div className="md:pl-4">
        <div className="mt-6 flex items-center">
          <BiGridAlt className="mr-5 min-w-[20px] max-w-[20px] max-h-[20px] min-h-[20px] dark:text-white" />
          <p className="dark:text-white truncate font-Inter text-[16px]">
            <span className="text-[#3C82F6]">Prompt: </span> {query}
          </p>
        </div>

        <div className="mt-6 flex items-center">
          <AiOutlineCalendar className="mr-5 w-[20px] h-[20px] dark:text-white" />
          <p className="dark:text-white font-Inter text-[16px]">
            <span className="text-[#3C82F6]">Task status: </span>
            {taskStatus === 'success' ? 'Successful' : 'Unsuccessful'}
          </p>
        </div>

        <div className="mt-6 flex items-center">
          <img
            alt="icon"
            src={theme === 'dark' ? '/icon3Dark.svg' : '/icon3.svg'}
            className="object-cover mr-5 w-[20px] h-[20px]"
          />
          <p className="dark:text-white font-Inter text-[16px]">
            <span className="text-[#3C82F6]">Execution time: </span>
            {`${executionTime} Sec`}
          </p>
        </div>

        <div className="mt-6 flex items-center justify-between">
          <div className="flex items-center">
            <img
              alt="icon"
              src={theme === 'dark' ? '/icon4Dark.svg' : '/icon4.svg'}
              className="object-cover mr-5 w-[20px] h-[20px]"
            />
            <p className="dark:text-white font-Inter text-[16px]">
              <span className="text-[#3C82F6]">Number of Subtasks: </span>
              {noOfSubtasks}
            </p>
          </div>
          <button
            onClick={() => onLogs(userInfo)}
            className="rounded-[5px] text-[9px] w-[70px] h-[27px] text-white font-Inter bg-[#666567]"
          >
            View More
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
